<template>
  <div id="LoginUser" :class="getModalClass">
    <b-loading :is-full-page="true" :active.sync="isLoading" ></b-loading>
    <header class="modal-card-head">
      <p class="modal-card-title">Acceder</p>
    </header>

    <section class="modal-card-body login-container">
      <div id="login-view">

          <b-field label="E-mail"
            :type="email_type"
            :message="email_message">
            <b-input
                      type="email"
                      v-model="inputs.email"
                      id="email"
                      placeholder="email"
                      ref="emailField"
                      required>
            </b-input>
          </b-field>
          <b-field
          label="Contraseña"
          :type="pwd_type"
          :message="pwd_message">
            <b-input
                      type="password"
                      v-model="inputs.password"
                      id="password"
                      placeholder="password"
                      required
                      expanded password-reveal
                      ref="passwordField"
                      @keydown.native.enter="handleEnterKey">
            </b-input>
          </b-field>
          <div style="text-align:right">
            <button class="btn btn-bg-colored is-primary is-fullwidth"  @click="login(inputs)" id="login-button">Acceder</button>
          </div>
        <div class = "aux-links is-flex" style="justify-content: space-between">
          <p>¿No tienes cuenta?
            <br/> <a href="#" @click="showRegister" class="">Crear cuenta</a>
          </p>
          <p style="margin-top: 2em">
            <router-link :to="{ name: 'resetPassword' }" >Resetear contraseña</router-link>
          </p>
        </div>
      </div>
    </section>

    <footer v-if="isModal" class="modal-card-foot">
      <button class=" btn" type="button" @click="close()">Cerrar</button>
    </footer>
  </div>
</template>
<script>

export default {
  name: 'LoginUser',
  props: {
    isModal: {
      type: Boolean,
      required: false,
      default: false
    },
    nextUrl: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      inputs: {
        email: '',
        password: ''
      },
      email_type: '',
      email_message: '',
      pwd_type: '',
      pwd_message: '',
      isLoading: false
    }
  },
  computed: {
    getModalClass () {
      if (this.isModal) return 'modal-card'
      else return ''
    },
    isInHome: function () {
      return this.$route.name === 'Home' || this.$route.name === 'Gallery'
    }
  },
  methods: {
    login ({ email, password }) {
      console.log(email)
      if (this.ifFormValid() === false) return
      this.$store.dispatch('auth/login', { email, password })
        .then((r) => {
          console.log('authenticated')
          if (this.isModal) {
            if (this.isInHome) this.$router.push('/user')
            this.close()
          } else this.$router.push('/user')
        })
        .catch((error) => {
          window.asdf = error
          console.log(error)
          if ('email' in error.response.data) {
            this.email_type = 'is-danger'
            this.email_message = error.response.data.email[0]
          } else if ('password' in error.response.data) {
            this.pwd_type = 'is-danger'
            this.pwd_message = error.response.data.password[0]
          } else if ('non_field_errors' in error.response.data) {
            this.email_type = 'is-danger'
            this.email_message = error.response.data.non_field_errors[0]
            this.pwd_type = 'is-danger'
          }
        })
        .finally(() => { this.isLoading = false })
    },
    close: function () {
      // this.$parent.close()
      this.$store.commit('setEditorConfigProperty', {'isShowingLogin': false})
    },
    saveAndClose: function () {
      /* this.$store.commit('setProjectTitle', this.title)
      this.$store.commit('setProjectDescription', this.description)
      this.hideSetings()
      this.$emit('save') */
    },
    ifFormValid () {
      var isValid = (this.$refs.emailField.checkHtml5Validity() && this.$refs.passwordField.checkHtml5Validity())
      return (isValid)
    },
    showRegister: function () {
      console.log('showRegister')
      if (this.isModal) {
        this.$store.commit('setEditorConfigProperty', {'isShowingRegister': true})
        this.$store.commit('setEditorConfigProperty', {'isShowingLogin': false})
      } else {
        this.$emit('showregister')
      }
    },
    handleEnterKey () {
      this.login(this.inputs)
      this.$refs.passwordField.$el.firstElementChild.blur()
    }
  }
}

</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.links {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Login/LoginUser.vue